export default "__VITE_ASSET__CDkvLIMB__"